/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgThumbsDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M20.568 3.126a1.56 1.56 0 00-1.043-.376H17.59v9.5h1.934a1.56 1.56 0 001.566-1.305v-6.89a1.56 1.56 0 00-.523-.929zm-4.477 9.715l-3.715 8.36a2.25 2.25 0 01-1.785-2.2v-4a.75.75 0 00-.75-.75H4.173a1.25 1.25 0 01-1.25-1.438l1.38-9a1.25 1.25 0 011.25-1.063H16.09v10.091zm3.414-11.59a3.06 3.06 0 013.08 2.649.751.751 0 01.006.1v7a.751.751 0 01-.006.1 3.06 3.06 0 01-3.08 2.65H17.33l-3.802 8.555a.75.75 0 01-.686.445A3.75 3.75 0 019.091 19v-3.25H4.185a2.75 2.75 0 01-2.745-3.162l1.38-9A2.752 2.752 0 015.565 1.25h13.94z'
      />
    </svg>
  );
}

export default SvgThumbsDown;
